








































import { defineComponent } from "@vue/composition-api";
import BaseFlexForm from "@/components/BaseFlexForm.vue";
import { FormFields, FormValues, Dictionary } from "@/types";
import { isEmpty } from "lodash-es";

export default defineComponent({
  name: "BlockBaseForm",
  components: { BaseFlexForm },
  props: {
    fields: { type: Array as () => FormFields, required: true },
    fieldsErrors: { type: Object as () => Dictionary<string[]>, default: () => ({}) },
    valid: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
    showCancel: { type: Boolean, default: true },
    flexClass: { type: String, default: "col-12 col-md-6" },
    buttonSaveText: { type: String, default: "Save" },
    buttonCancelText: { type: String, default: "Cancel" },
  },
  data() {
    return {
      currentValues: {} as FormValues,
    };
  },
  computed: {
    values: {
      get(): FormValues {
        if (!isEmpty(this.currentValues)) return this.currentValues;
        const result: FormValues = {};
        this.fields.forEach(item => {
          result[item.name] = item.value !== undefined ? item.value : null;
        });
        this.currentValues = result;
        return result;
      },
      set(values: FormValues) {
        this.currentValues = values;
        this.$emit("input", values);
      },
    },
  },
  watch: {
    fields(newFields: FormFields, oldFields: FormFields) {
      const result: FormValues = {};
      newFields.forEach(item => {
        const newBaseValue = item.value !== undefined ? item.value : null;
        const oldField = oldFields.find(i => i.name === item.name);
        if (!oldField || (newBaseValue !== oldField.value && oldField.value === this.currentValues[oldField.name])) {
          result[item.name] = newBaseValue;
        }
      });
      Object.assign(this.currentValues, result);
    },
  },
  methods: {
    cancel() {
      this.clearAll();
      this.$emit("cancel");
    },
    clearAll() {
      this.values = {};
    },
    save() {
      this.$emit("save", this.currentValues, this);
    },
  },
  created() {
    this.$emit("input", this.values);
  },
});
